import { useCallback, useEffect, useState } from "react";

import { formatSSN, isValidSSN } from "@/shared/utils/formatters";

export const SSN_VALIDATION_MESSAGE = "Social Security number must be 9 digits, like XXX-XX-XXXX";

export function useSSNField(decryptedSSN: string | null | undefined) {
  const [ssnValue, setSsnValue] = useState("");
  const [ssnVisible, setSsnVisible] = useState(false);
  const [ssnInputKey, setSsnInputKey] = useState(0);

  useEffect(() => {
    if (decryptedSSN && !ssnValue && isValidSSN(decryptedSSN)) {
      setSsnValue(formatSSN(decryptedSSN));
    }
  }, [decryptedSSN, ssnValue]);

  const remountInput = useCallback(() => setSsnInputKey((k) => k + 1), []);

  return {
    ssnValue,
    setSsnValue,
    ssnVisible,
    setSsnVisible,
    ssnInputKey,
    remountInput,
  };
}
